import PropTypes from 'prop-types';
import React from 'react';
import { Button, Intent } from '@blueprintjs/core'

function DialogButtonGroup({onSave, onCancel}) {
  return (
    <div className="align-right" style={{paddingTop: 10}}>
      <Button text="Cancel" onClick={onCancel} style={{marginRight: 10, width: 65}}/>
      <Button text="Save" intent={Intent.PRIMARY} onClick={onSave} style={{width: 65}}/>
    </div>
  )
}

DialogButtonGroup.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default DialogButtonGroup



/** WEBPACK FOOTER **
 ** ./client/components/blueprint/DialogButtonGroup.js
 **/